import { useGetNsfDetailsQuery } from "types/generated/operations";

export const useNsfDetails = (objectFlagId: string) => {
  const { data } = useGetNsfDetailsQuery({
    variables: { objectFlagId: objectFlagId },
  });

  return data;
};
